import { render, staticRenderFns } from "./research_literature.vue?vue&type=template&id=cc6ca396&scoped=true&"
import script from "./research_literature.vue?vue&type=script&lang=js&"
export * from "./research_literature.vue?vue&type=script&lang=js&"
import style0 from "./research_literature.vue?vue&type=style&index=0&id=cc6ca396&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6ca396",
  null
  
)

export default component.exports